import axios from "axios";
import adapters from "axios/unsafe/adapters/adapters.js";
import flutterAdapters from "./flutterRequest"
import service from "@hybird/core/request";
import request from "@hybird/device/request";
import {flutterCamera} from "@hybird/flutter/bridge/camera";

function parseFile(file, hasKey = false) {
  if (file.toFile) {
    file = file.toFile();
  } else if (file instanceof File) {
    if (!hasKey) {
      return {file: file};
    } else {
      return file;
    }
    // eslint-disable-next-line no-empty
  } else if (typeof file === "string") {
    if (!file.startsWith("file://")) {
      file = `file://${file}`;
    }
  } else if (typeof file === "object") {
    const data = {};
    for (const i in file) {
      let tmpFile = file[i];

      data[i] = parseFile(tmpFile, true);
    }

    return data;
  } else {
    return file;
  }

  if (!hasKey) {
    return {file};
  } else {
    return file;
  }
}

/**
 *
 * @param file {String|{toFile:function}|{String:String}|{String:{toFile:function}}}
 * @param url{String} 上传的地址
 * @param config{axios.AxiosRequestConfig|{download:{savePath:String, basePath:String}}}
 * @param formData{object}
 * @return {Promise<Promise<void> | Promise<T>>}
 */
service.uploadFile = async (
        file,
        url = request.fileUpload,
        config = {},
        formData = {},
        options = {}
) => {
  console.log(' jjjjjjjjj---service.uploadFile', JSON.stringify(file))

  //兼容旧数据
  let { autoDeleteFille = true, externalTriggerDeletion = false} = typeof options === "object" ? options : {autoDeleteFille: options};
  let _result = null;
  return service.postForm(
          url,
          {
            ...parseFile(file),
            ...formData,
          },
          config
  ).then((result) => {
    _result = result;
    console.log('deleteFilesByPaths=then',autoDeleteFille,'file',JSON.stringify(file),JSON.stringify(_result));
    
    if (!autoDeleteFille && !externalTriggerDeletion && _result?.success) {
      flutterCamera.deleteFilesByPaths([file]);
    }

    return result;
  }).finally(() => {
    console.log('deleteFilesByPaths=finally',autoDeleteFille,'file',JSON.stringify(file),JSON.stringify(_result));
    if (autoDeleteFille && _result?.success) {
      flutterCamera.deleteFilesByPaths([file]);
    }
  });
};

export default () => {
  adapters.adapters["flutter"] = flutterAdapters;
  axios.getAdapter = adapters.getAdapter;
}

export {flutterAdapters};